import Vue from 'vue'
import ProfilePicture from './components/ProfilePicture'
import store from "../../../store";

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#vueUserProfile',
  store,
  components: { ProfilePicture },
})



// WEBPACK FOOTER //
// ./src/main/frontend/vue/js/modules/user/profile/index.js